import {get} from "lodash";
import * as React from "react";
import {BASE_STORAGE_URL} from "constants.js";
import {useState} from "react";

export const ReducerStatuses = {
    IDLE: "idle",
    LOADING: "loading",
    SUCCESS: "success",
    ERROR: "error"
};
export const getErrorFromMessage = (e) => {
    return get(e, 'response.data.errors', ['generic_error'])[0];
}

export const AppAreasRedirects = {
    LoggedOut: "/app-courtesy",
    Onboarding: "/app-courtesy",
    LoggedIn: "/app-courtesy"
};

export const calculateRedirectBasedOnAuth = ({isLoggedIn, hasTempPassword, hasDoneOnboarding}) => {
    if(hasTempPassword || !isLoggedIn) {
        return AppAreasRedirects.LoggedOut;
    }
    if(!hasDoneOnboarding) {
        return AppAreasRedirects.Onboarding;
    }
    return AppAreasRedirects.LoggedIn;
}

export const formatStringToCardNumber = (str) => {
    return str.replace(/ /g, "").replace(/[^\d0-9]/g, '').replace(/(.{4})/g, '$1 ').trim();
}
export const formatStringToCardExpiration = (str) => {
    return str.replace(/\//g, "").replace(/[^\d0-9]/g, '').replace(/(.{2})/, '$1/').trim();
}

export const b64toBlob = (b64DataRaw, contentType='', sliceSize=512) => {
    const regex = /base64,(.+)$/
    const regexResult = b64DataRaw.match(regex);
    const b64Data = regexResult ? regexResult[1] : b64DataRaw;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, {type: contentType});
}

export const generateFullUrl = (url) => {
    if (!url) return url;
    if(typeof url !== "string") return null;
    if(url.startsWith("data:") || url.startsWith("http")) return url;
    return `${BASE_STORAGE_URL}${url}`
};
export const checkIfItsUrl = (url) => {
    if (!url) return url;
    if(typeof url !== "string") return null;
    if(url.startsWith("http")) return url;
    return `http://${url}`;
}
export const getVimeoIdFromUrl = (url) => {
    const regex = /\/([0-9]+)/;
    const matches = url.match(regex);
    return (matches && matches.length >= 2) ? matches[1] : null;
}

/* istanbul ignore next */
export const useMediaQuery = (maxWidth) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const resizeListener = () => {
        setWindowWidth(window.innerWidth);
    };
    React.useEffect(() => {
        window.addEventListener("resize", resizeListener);
        return () => window.removeEventListener("resize", resizeListener);
    });
    return windowWidth < maxWidth;
}

/* istanbul ignore next */
export const useOnClickOutside = (ref, handler) => {
    React.useEffect(
        () => {
            const listener = event => {
                if (!ref.current || ref.current.contains(event.target)) {
                    return;
                }
                handler(event);
            };
            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);
            return () => {
                document.removeEventListener('mousedown', listener);
                document.removeEventListener('touchstart', listener);
            };
        },
        [ref, handler]
    );
}
export const indexesOf = (string, regex) => {
    let match, indexes = {};
    // eslint-disable-next-line no-cond-assign
    while (match = regex.exec(string)) {
        if (!indexes[match[0]]) indexes[match[0]] = [];
        indexes[match[0]].push(match.index);
    }

    return indexes;
}
export const ciCompare = (item, compare) => {
    return item.toLowerCase().indexOf(compare.toLowerCase()) > -1;
}
